/**
 * This middleware handles promo codes to be injected in
 * the POST request when a user is created. Promo codes can
 * be stored in cookies or from the Branch.io service.
 */

import { getCookie } from 'stash/utils/cookies';
import { POST_USER_REQUEST } from 'stash/actions/api/user';
import { STASH_INIT } from 'stash/actions/init';
import {
	createSuperCookie,
	setSuperCookie,
	getSuperCookie,
} from 'stash/utils/superCookie';

export const PROMO_COOKIE_NAME = 'stashPromoCode';
export const PROMO_PARAM_NAME = 'stash_code';
export const PROMO_V2_COOKIE_NAME = 'stashPromoCodeV2';

const promoMiddleware = () => (next) => (action) => {
	// Persist promocode or branch code in a cookie on load.
	if (action.type === STASH_INIT) {
		// Promo codes are written only to the super cookie (individual promo cookies removed).
		const superCookie = createSuperCookie();
		if (superCookie) {
			setSuperCookie(superCookie);
		}
	}

	// Get promocode from cookies or branch on a new user POST.
	if (action.type === POST_USER_REQUEST) {
		// Prefer super cookie (source of truth), fall back to individual cookies
		const superCookie = getSuperCookie();
		const referralSourceCode =
			superCookie?.promoCode || // V2 promo code from super cookie
			superCookie?.legacyPromoCode || // Legacy promo code from super cookie
			getCookie(PROMO_V2_COOKIE_NAME) || // V2 promo code from individual cookie
			getCookie(PROMO_COOKIE_NAME); // Legacy promo code from individual cookie

		return next({
			...action,
			request: {
				...action.request,
				body: {
					...action.request.body,
					referral_source_code: referralSourceCode,
				},
			},
		});
	}

	return next(action);
};

export default promoMiddleware;
